import * as React from "react"
import type { SVGProps } from "react"
const SvgLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 13.14a1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72q0-.42.29-.71a1 1 0 0 1 .71-.29h14q.42 0 .71.29.3.3.29.71c-.01.41-.1.52-.29.72a1 1 0 0 1-.71.28z" />
  </svg>
)
export default SvgLine
